<script>
import { defineComponent } from 'vue'
import { Head } from '@inertiajs/vue3'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import { useCallbackStore } from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue"

import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForLSTCPage",
    components: { Head, InfoCards, Breadcrumbs, MobileTopBar, FaqComponent },
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'Марка стали и толщина — строго по ТЗ',
                    description: 'Рулон/лист для профилирования: подтверждаем марку стали и реальную толщину, поставляем в соответствии с ГОСТ/ТУ.',
                },
                {
                    logo: certificate_svg,
                    title: 'Сертификаты и прослеживаемость партий',
                    description: 'Передаём МК/сертификаты завода. В закрывающих фиксируем номер партии/плавки — удобно для входного контроля.',
                },
                {
                    logo: clock_svg,
                    title: '«Точно в срок» под график линии',
                    description: 'При наличии — отгрузка день-в-день со складов Москвы и МО. Формируем календарь регулярных поставок.',
                },
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'Спеццены на объём и контракты',
                    description: 'Индивидуальные условия под крупные партии и регулярные закупки. Фиксация цены на согласованный период.',
                },
                {
                    logo: delivery_svg,
                    title: 'Сохранность при доставке',
                    description: 'Упаковка, прокладки, стяжка, маркировка мест — аккуратная разгрузка и удобный складской учёт.',
                },
                {
                    logo: star_svg,
                    title: 'Непрерывность снабжения',
                    description: 'Резервирование объёмов, персональный менеджер, SLA по срокам — без остановок линии профилирования.',
                },
            ],
            faqItems: [
                {
                    question: 'Что поставляете для производства ЛСТК?',
                    answer: `<p>Поставляем <strong>оцинкованный рулон и лист</strong> для профилирования (штрипс), а также сопутствующий металлопрокат: швеллеры, уголки и др. Подбираем под ваше ТЗ: <strong>марка стали</strong>, <strong>толщина</strong>, <strong>ширина</strong>, <strong>тип покрытия</strong>.</p>`
                },
                {
                    question: 'Делаете резку штрипса и раскрой листа «в размер»?',
                    answer: `<p>Да. Режем рулон на <strong>штрипс</strong> и выполняем <strong>раскрой листа</strong> по картам/чертежам. Согласуем допуски, обеспечиваем повторяемость партий, упаковываем и маркируем для удобной подачи на линию.</p>`
                },
                {
                    question: 'Как удерживаете сроки поставок под график производства?',
                    answer: `<p>При наличии на складе — <strong>отгрузка день-в-день</strong>. На контрактных поставках формируем календарь и закрепляем слоты под ваш транспорт или нашу доставку. Отслеживаем статусы и уведомляем о движении груза.</p>`
                },
                {
                    question: 'Минимальный объём и возможна ли фиксация цены?',
                    answer: `<p>Ориентир — от <strong>5 тонн</strong>. По договорённости фиксируем цену на согласованный срок под план производства и ритмику поставок.</p>`
                },
                {
                    question: 'Работаете с НДС и ЭДО? Передаёте сертификаты?',
                    answer: `<p>Да, <strong>НДС</strong> и <strong>ЭДО</strong> поддерживаем. Передаём МК/сертификаты завода-изготовителя; в документах — номера партий/плавок для полной прослеживаемости.</p>`
                },
            ],
        }
    },
    methods: {
        openForm() {
            this.callbackStore.showBaseCallbackPopup({
                title: 'Запросить КП для ЛСТК',
                bitrix_title: 'Заявка на партнёрство (ЛСТК • металлопрокат)',
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return { callbackStore }
    }
})
</script>

<template>
    <div>
        <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white" color="#ffcf33"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                                B2B-решения для производителей ЛСТК
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Металл для профилирования: <strong>оцинкованный рулон</strong>, <strong>лист</strong>, <strong>штрипс</strong>. Стабильная толщина, сертификаты, поставки «точно в срок».
                            </p>
                            <button
                                @click.prevent="openForm"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                            >
                                Запросить КП
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center max-md:hidden">
                        <img
                            src="@img/b2b/lstk/top-bg.webp"
                            class="max-h-[500px] rounded-full aspect-square object-cover"
                            alt="Металлопрокат для ЛСТК: рулонная и листовая оцинкованная сталь"
                            title="Поставки металлопроката для производителей ЛСТК"
                        />
                    </div>
                </div>
            </div>
        </div>
        <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
            <div class="container pt-10 md:pt-20">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Что мы делаем для ЛСТК-производителей
                </h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 h-full">
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Рулон/лист строго по размерам</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Резка <span class="whitespace-nowrap">штрипса</span> «в размер»</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Раскрой листа по картам/чертежам</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Комплектовка под линию/смены</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Упаковка и маркировка мест</p>
                            </div>
                            <div class="flex flex-col items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-sm md:text-base lg:text-lg">
                                <p>Доставка по Москве и МО</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img
                            src="@img/b2b/lstk/main.webp"
                            class="object-contain"
                            alt="Поставки рулонной и листовой оцинкованной стали для ЛСТК"
                            title="ЛСТК: металл для профилирования — рулон/лист/штрипс"
                        />
                    </div>
                </div>
            </div>
        </section>
        <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20" />
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Снимаем рутину снабжения у производств
                    </h2>
                    <p class="mb-3">
                        Закрываем подбор по ТЗ/ГОСТ/ТУ, резку штрипса и раскрой листа, упаковку/маркировку и логистику — чтобы линия не простаивала.
                    </p>
                    <p class="mb-3">
                        Учитываем требования к стабильности толщины и покрытия, а также специфику подачи металла на профилировочные станы.
                    </p>
                    <p class="mb-3">Берём на себя:</p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>подбор рулона/листа по марке стали, толщине и ширине;</li>
                        <li>резку штрипса и раскрой с контролем допусков;</li>
                        <li>комплектовку, маркировку мест и упаковочные листы;</li>
                        <li>логистику «до ворот»/на площадку, погрузку-разгрузку.</li>
                    </ul>
                </div>
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Как начать сотрудничество
                    </h2>
                    <p class="mb-3">
                        Оставьте заявку — подготовим КП под объём и ритмику поставок, согласуем SLA и закрепим персонального менеджера.
                    </p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>спецусловия для крупных партий и контрактов;</li>
                        <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                        <li>полный пакет документов: НДС, ЭДО, возможна отсрочка.</li>
                    </ul>
                    <button
                        @click.prevent="openForm"
                        class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
        <section class="container">
            <FaqComponent
                title="FAQ для производителей ЛСТК"
                subtitle="Ассортимент, резка/раскрой, сроки и ритмика поставок, объёмы, НДС/ЭДО и сертификаты."
                :items="faqItems"
                schema-id="schema-lstk-faq-jsonld"
            />
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
